import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAssetSwitcher from "@components/WebsiteRevamp/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {
	data: AdvancedSideAssetModuleType
}

const ExpertiseIntro = (props: Props) => {
	return (
		<section>
			<ContainerWrapper>
				{/* <Separator size={128} />
				<Typography
					content={props.data.sectionTitle}
					fontWeight={300}
					variant={Variant.SectionTitle}
				/>
				<Separator /> */}
				<Separator size={128} />

				<ContentAssetSwitcher
					contentAssetProps={{
						withAspectRation: true,
					}}
					data={props.data}
				/>
			</ContainerWrapper>
		</section>
	)
}

export default ExpertiseIntro
